import { useParamsSearch } from '@anytag/shared-hooks';
import { CampaignPostsDiscoverySearchType } from '../schemaTypes';

export const useCampaignPostsDiscoveryFilter = () => useParamsSearch<CampaignPostsDiscoverySearchType>();
